/**
 * Die Schriftfarbe, die auf der Akzentfarbe des Betriebs lesbar bleibt.
 *
 * Die Farbe kommt aus den Einstellungen des Kunden und kann alles sein. Ein Betrieb mit
 * einem hellen Gelb als Akzentfarbe bekaeme sonst weisse Schrift auf gelbem Grund — auf
 * seiner eigenen Website, vor Angehoerigen, die ohnehin unter Druck stehen.
 *
 * Gerechnet wird mit der wahrgenommenen Helligkeit nach der ueblichen Gewichtung der drei
 * Kanaele; Gruen wiegt am schwersten, Blau am leichtesten.
 */
const DUNKEL = "#1a202c";
const HELL = "#ffffff";

export const lesbareSchriftfarbe = (hintergrund: string): string => {
  const roh = (hintergrund ?? "").trim().replace(/^#/, "");

  // Kurzform wie "fff" auf die lange Form bringen.
  const hex = roh.length === 3 ? roh.replace(/./g, zeichen => zeichen + zeichen) : roh;
  if (!/^[0-9a-fA-F]{6}$/.test(hex)) return HELL;

  const rot = parseInt(hex.slice(0, 2), 16);
  const gruen = parseInt(hex.slice(2, 4), 16);
  const blau = parseInt(hex.slice(4, 6), 16);

  const helligkeit = (rot * 299 + gruen * 587 + blau * 114) / 1000;

  // Ab dieser Helligkeit traegt der Grund keine weisse Schrift mehr.
  return helligkeit > 150 ? DUNKEL : HELL;
};
